var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"mode":"range","popover":{ placement: _vm.placement, visibility: 'click' },"columns":_vm.calendarLayout.columns,"rows":_vm.calendarLayout.rows,"is-expanded":_vm.calendarLayout.isExpanded,"locale":_vm.locale,"input-props":{
    placeholder: _vm.$t('components.core.date-range-calendar.placeholder')
  }},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f9e55e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/DateRangeCalendar.vue
// module id = null
// module chunks = 